import React, { Suspense } from 'react'

const RetargetingPageBase = React.lazy(() => import('./Retargeting'))

export const RetargetingPage = () => (
  <Suspense fallback={null}>
    <RetargetingPageBase />
  </Suspense>
)
